export default __webpack_public_path__ + "static/log-axis-39bf6d3bfae9d5dda90ab01446558fbf.png";